import * as APITypes from '../../graphql/API';

export const schools = /* GraphQL */ `
  query Schools(
    $filter: SchoolsFilter
    $scannedCount: Int
    $nextToken: String
  ) {
    schools(
      filter: $filter
      scannedCount: $scannedCount
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        nameArabic
        name
      }
      nextToken
      scannedCount
    }
  }
`;

export const school = /* GraphQL */ `
  query School($id: String!) {
    school(id: $id) {
      id
      createdAt
      updatedAt
      nameArabic
      name
      promo {
        id
        createdAt
        updatedAt
        type
        thumbnailUri
        fileUri
        title_i18n
        subTitle_i18n
        position
        __typename
      }
      __typename
    }
  }
`;
export const customClassSchoolStudents = /* GraphQL */ `
  query Classschool($id: String!) {
    classschool(id: $id) {
      id
      createdAt
      updatedAt
      name
      schoolYear
      students {
        id
        __typename
      }
      __typename
    }
  }
`;

export const classSchoolWithStudentsEnrollments = /* GraphQL */ `
  query Classschool($id: String!) {
    classschool(id: $id) {
      id
      createdAt
      updatedAt
      name
      schoolYear
      students {
        id
        createdAt
        updatedAt
        name
        age
        birthDate
        gender
      }
      __typename
    }
  }
`;
